import React from "react"
import { Link } from "react-router-dom"

const Language = ({ className, to, language, disabled, onKeyDown }) => {
	const ariaLabel = language === "FI" ? "Suomeksi" : "English"
	return (
		<Link className={className} to={to} aria-label={ariaLabel} disabled={disabled} onKeyDown={onKeyDown}>
			{language}
		</Link>
	)
}

export default Language
